import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

import { IBottomDrawerProps } from '@rbilabs/components-library/build/components/bottom-drawer';
import { IStyledComponent } from 'styled-components';

import { LoyaltyOffer } from 'state/loyalty/types';

export interface ILoyaltyPromoCodeDrawerProps extends Pick<IBottomDrawerProps, 'dialogState'> {
  onDismiss: VoidFunction;
  promoCode?: string;
  setPromoCodeRef: (promoCode: string) => void;
  onPromoCodeRedeemSuccess?: (offer: LoyaltyOffer) => void;
}

export type IPromoCodeProps = Pick<ILoyaltyPromoCodeDrawerProps, 'onPromoCodeRedeemSuccess'> & {
  CTAComponent?: IStyledComponent<
    'web',
    Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, never>
  >;
  CTAText?: string;
};

export interface LoyaltyPromoCodeCTAProps {
  onClick: VoidFunction;
}

export enum PromoCodeErrorReason {
  redeemedCode = 'REDEEMED_CODE',
  expiredCode = 'EXPIRED_CODE',
  invalidCode = 'INVALID_CODE',
  userNotEligible = 'USER_NOT_ELIGIBLE',
}

export class PromoCodeError extends Error {
  public message: PromoCodeErrorReason;

  constructor(message: PromoCodeErrorReason) {
    super();
    this.message = message;
  }
}
